import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, module }) {
  const { user, loading, can } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-50" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-indigo-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (module && !can(module, "view")) {
    return (
      <div className="flex h-[60vh] flex-col items-center justify-center text-center" data-testid="access-denied">
        <h2 className="font-heading text-2xl font-bold text-slate-800">Access denied</h2>
        <p className="mt-2 text-sm text-slate-500">You don't have permission to view this module.</p>
      </div>
    );
  }
  return children;
}
